<div class="flex flex-col w-full p-6 tab-frame">
    <div class="flex justify-between mt-4 mb-10">
        <div class="text-center">
            <div class="text-2xl text-primary"><b>Crown Valve (CV)</b></div>
        </div>

        <div class="flex justify-end">
            <div class="flex items-center">
                <div [ngClass]="{'font-bold': !isReplace}">Edit</div>
                <input type="checkbox" class="toggle bg-primary mx-2" [(ngModel)]="isReplace"
                    [disabled]="disabledToggle" />
                <div [ngClass]="{'font-bold': isReplace}">Replace</div>
            </div>
        </div>
    </div>

    <app-form [data]="cvForm"></app-form>

    <div class="flex justify-end">
            <span *ngIf="!cvForm.sceXmasTreeId" class="flex items-end mr-3 font-medium text-gray-400 italic text-md">
                <i> Please insert the XMAS Tree details first before {{ isReplace ? 'saving' : 'updating' }}.</i>
            </span>
        <button class="btn btn-primary" [disabled]="disabledSave()" (click)="save()"> {{ isReplace ? 'Save' : 'Update'
            }} </button>
    </div>
</div>